
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mq",
      function () {
        return require("private-next-pages/mq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mq"])
      });
    }
  